import React from 'react';
import { Menu, Icon, Tooltip } from 'antd';
import { Link, withRouter } from "react-router-dom";

const SubMenu = Menu.SubMenu;

class Menuitems extends React.Component {

  state = {
    openKeys: ['sub1'],
    //切換靜or動態MENU
    defaultMode: false,
  };

  //antd 控制側邊MENU只會有一個父節點展開
  onOpenChange = (openKeys) => {
    let latestOpenKey;
    // IE 11 不支援下面兩種寫法
    // const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    // for (let node of openKeys) {
    //   if (this.state.openKeys.indexOf(node) === -1) {
    //     latestOpenKey = node;
    //   }
    // }
    openKeys.forEach(element => {
      if (this.state.openKeys.indexOf(element) === -1) {
        latestOpenKey = element;
      }
    });

    if (this.props.root_SubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    }
    else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }

  //靜態MENU
  renderDefault = () => {
    return (
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={this.state.defaultSelectedKeys}
        openKeys={this.state.openKeys}
        onOpenChange={this.onOpenChange}
        onSelect={this.onSelect}
      >
        <div className="logoField">
          <img src="logo.png" alt="infodoc" style={{ width: 165, height: 40, display: 'block', margin: 'auto' }} />
        </div>
        <SubMenu key="sub1" title={<span><Icon type="user" /><span>使用手冊</span></span>}>
          <Menu.Item key="1"><Link to="/antd/"><span>共用功能</span></Link></Menu.Item>
          <Menu.Item key="2"><Link to="/page1"><span>承辦人作業</span></Link></Menu.Item>
        </SubMenu>
        <SubMenu key="sub2" title={<span><Icon type="area-chart" /><span>簡易操作手冊</span></span>}>
          <Menu.Item key="3"><Link to="/page2"><span>創稿作業</span></Link></Menu.Item>
          <Menu.Item key="4"><Link to="/page3"><span>來文擬辦</span></Link></Menu.Item>
        </SubMenu>
        <SubMenu key="sub3" title={<span><Icon type="delete" /><span>影音教學</span></span>}>
          <Menu.Item key="5"><span>承辦人作業</span></Menu.Item>
          <Menu.Item key="6"><span>單位登記桌作業</span></Menu.Item>
          <Menu.Item key="7"><span>總收文作業</span></Menu.Item>
          <SubMenu key="sub4" title={<span><Icon type="delete" /><span>P1</span></span>}>
            <Menu.Item key="11"><span>C1</span></Menu.Item>
            <SubMenu key="sub5" title={<span><Icon type="delete" /><span>P2</span></span>}>
              <Menu.Item key="12"><span>C2</span></Menu.Item>
              <SubMenu key="sub6" title={<span><Icon type="delete" /><span>P3</span></span>}>
                <Menu.Item key="13"><span>C3</span></Menu.Item>
                <Menu.Item key="14"><span>C4</span></Menu.Item>
              </SubMenu>
              <SubMenu key="sub7" title={<span><Icon type="delete" /><span>P4</span></span>}>
                <Menu.Item key="15"><span>C5</span></Menu.Item>
              </SubMenu>
            </SubMenu>
          </SubMenu>
        </SubMenu>
        <Menu.Item key="8">
          <Icon type="user" />
          <span>新版調案單流程說明</span>
        </Menu.Item>
        <Menu.Item key="9">
          <Icon type="video-camera" />
          <span>派繕批次作業說明</span>
        </Menu.Item>
        <Menu.Item key="10">
          <Tooltip placement="right" title={<span>新增原新聞局自動轉置案卷二層級資料</span>}>
            <Icon type="upload" />
            <span>新增原新聞局自動轉置案卷二層級資料</span>
          </Tooltip>
        </Menu.Item>
      </Menu>
    );
  }

  //動態產生MENU，遞迴
  renderDynamic = (MenuData) => {
    return (MenuData.map((menu) => {
      //若為父節點
      if (menu.children) {
        return (
          <SubMenu key={menu.id} title={<span><Icon type={menu.icon} style={{ fontSize: 18, color: '#6CCFF6' }} /><span>{menu.title}</span></span>}>
            {this.renderDynamic(menu.children)}
          </SubMenu>);
      }
      else {
        //判斷是否有tooltip
        if (menu.tooltip) {
          return (
            <Menu.Item key={menu.path}>
              <Tooltip placement="rightTop" overlayClassName={menu.tooltipcolor} title={menu.tooltip}>
                <Link to={menu.path}>
                  <Icon type={menu.icon} style={{ fontSize: 18 }} />
                  <span>{menu.title}</span>
                </Link>
              </Tooltip>
            </Menu.Item>
          );
        }
        else {
          return (
            <Menu.Item key={menu.path}>
              <Link to={menu.path}>
                <Icon type={menu.icon} style={{ fontSize: 18 }} />
                <span>{menu.title}</span>
              </Link>
            </Menu.Item>
          );
        }
      }
    })
    );
  }

  render() {
    return this.state.defaultMode ?
      this.renderDefault() :
      (
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[this.props.location.pathname]}
          openKeys={this.state.openKeys}
          onOpenChange={this.onOpenChange}
          onSelect={this.onSelect}
        >
          {/* 左上角LOGO與名稱區域 */}
          <div className="logoField">
            <Link to="/" style={{ textDecoration: 'none' }}>
              <h3 style={{ display: 'inline-flex' }}>
                <img src={this.props.logoPath} alt="infodoc" style={{ width: 40, height: 40, margin: 'auto' }} />
                <span className="logoText">{this.props.text.split(" ")[0]}<br />{this.props.text.split(" ")[1]}</span>
              </h3>
            </Link>
          </div>
          {this.renderDynamic(this.props.Menu_data)}
        </Menu>
      );
  }
}

export default withRouter(Menuitems);


// WEBPACK FOOTER //
// ./src/components/Menuitems.js